"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M16.7827 3H3.21675C2.13475 3 1.59275 4.21061 2.35875 4.92097L7.72175 10.5258C7.90075 10.7129 7.99975 10.96 7.99975 11.2182V15.5624C7.99975 15.7515 8.10675 15.9245 8.27675 16.0096L11.2767 17.9466C11.6087 18.1127 11.9997 17.8715 11.9997 17.4993V11.2182C11.9997 10.96 12.0997 10.7119 12.2777 10.5248L17.6407 4.92097C18.4067 4.21061 17.8647 3 16.7827 3Z",
    fill: "#727B7F"
  }));
};